import { PreProcessor } from 'api/requestUtils'
import { AppStore } from 'src/client/store'
import qs from 'qs'

export default function localesLoader(store: AppStore): PreProcessor {
  return (params) => {
    if (params.options?.locales === 'include') {
      const s = store.getState()
      if (s.config.locales.length) {
        let paramsPrefix = '?'
        if (params.path.endsWith('?')) {
          paramsPrefix = ''
        } else if (params.path.includes('?')) {
          paramsPrefix = '&'
        }

        const query = qs.stringify({ locales: s.config.locales }, { arrayFormat: 'indices' })

        params.path += paramsPrefix + query

        delete params.options.locales
      }
    }
    return params
  }
}
